import { ActionModalType } from 'UI/Types/types'

export type UiState = {
  snackBarCopy: ActionModalType
  snackBarVisible: boolean
  screenType: 'mobile' | 'desktop'
  currentPage: number
}

const initialState = {
  snackBarCopy: null,
  snackBarVisible: false,
  screenType: null,
  currentPage: null
}

export default initialState
